import React, { useState } from 'react';
import {
  Form, Button, Row, Col,
} from 'react-bootstrap';
import PropTypes from 'prop-types';

import { getClientInformation } from '../../../api/services/ClientInfo';

const InputClient = ({
  client, setClient, resetPage, setFormDisabled,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setClient((prev) => ({
      ...prev,
      clientId: e.target.value,
    }));
  };

  const handleClick = async () => {
    resetPage();
    setIsLoading(true);

    getClientInformation(client.clientId)
      .then((res) => {
        if (res.data.data.clientId) {
          const { data } = res.data;

          setClient((prev) => ({
            ...prev,
            clientId: data.clientId,
            firstName: data.firstName,
            lastName: data.lastName,
            birthDate: data.dateOfBirth,
            contactPreference: '',
            email: data.email ? data.email : '',
            phone: data.phone ? data.phone : '',
          }));

          setFormDisabled(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <Form>
      <h3>Client ID</h3>
      <Row className="d-flex align-items-center">
        <Col xs={2}>
          <Form.Control
            type="number"
            id="client-id"
            value={client.clientId}
            onChange={handleChange}
            placeholder="Enter Credible ID"
          />
        </Col>
        <Col xs={1}>
          <Button onClick={handleClick}>Submit</Button>
        </Col>
        <Col xs={8} style={{ fontWeight: 'bold', fontSize: '1.25em', fontStyle: 'italic' }}>
          {isLoading && 'Loading Client...'}
          {client.lastName && `${client.lastName}, ${client.firstName}, ${client.birthDate}`}
        </Col>
      </Row>
    </Form>
  );
};

InputClient.propTypes = {
  client: PropTypes.shape({
    clientId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    birthDate: PropTypes.string.isRequired,
  }).isRequired,
  setClient: PropTypes.func.isRequired,
  resetPage: PropTypes.func.isRequired,
  setFormDisabled: PropTypes.func.isRequired,
};

export default InputClient;
